<div class="bg-gradient-to-r from-gray-300 to-gray-200">
    <div class="flex items-center justify-center w-9/12 min-h-screen py-16 m-auto">
        <div class="pb-8 overflow-hidden bg-white shadow-xl sm:rounded-lg">
            <div class="pt-8 text-center border-t border-gray-200">
                <h1 class="font-bold text-sigma-100 text-9xl">404</h1>
                <h1 class="py-8 text-6xl font-medium">
                    Página no encontrada
                </h1>
                <p class="px-12 pb-8 text-2xl font-medium">
                    ¡UPS! La página que busca no existe. Puede que se haya movido o eliminado.
                </p>

                <button routerLink="/home"
                    class="px-6 py-3 mr-6 font-semibold text-white uppercase transition-colors duration-200 transform rounded-md bg-sigma-300 hover:bg-sigma-100">
                    Inicio
                </button>
                <a href="/home#scrollcontacts"
                    class="px-6 py-3 font-semibold text-white uppercase transition-colors duration-200 transform bg-gray-500 rounded-md hover:bg-gray-600">
                    Cont&aacute;ctanos
                </a>
            </div>
        </div>
    </div>
</div>